import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTinymedicPatientOrders } from 'app/entities/tinymedic-patient-order/tinymedic-patient-order.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tinymedic-patient-order-file.reducer';

export const TinymedicPatientOrderFileUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tinymedicPatientOrders = useAppSelector(state => state.tinymedicPatientOrder.entities);
  const tinymedicPatientOrderFileEntity = useAppSelector(state => state.tinymedicPatientOrderFile.entity);
  const loading = useAppSelector(state => state.tinymedicPatientOrderFile.loading);
  const updating = useAppSelector(state => state.tinymedicPatientOrderFile.updating);
  const updateSuccess = useAppSelector(state => state.tinymedicPatientOrderFile.updateSuccess);

  const handleClose = () => {
    navigate(`/tinymedic-patient-order-file${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTinymedicPatientOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tinymedicPatientOrderFileEntity,
      ...values,
      tinymedicPatientOrder: tinymedicPatientOrders.find(it => it.id.toString() === values.tinymedicPatientOrder?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tinymedicPatientOrderFileEntity,
          tinymedicPatientOrder: tinymedicPatientOrderFileEntity?.tinymedicPatientOrder?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tinymedicPatientOrderFile.home.createOrEditLabel" data-cy="TinymedicPatientOrderFileCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.home.createOrEditLabel">
              Create or edit a TinymedicPatientOrderFile
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tinymedic-patient-order-file-id"
                  label={translate('tinyMedicRestApp.tinymedicPatientOrderFile.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tinymedicPatientOrderFile.name')}
                id="tinymedic-patient-order-file-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tinymedicPatientOrderFile.active')}
                id="tinymedic-patient-order-file-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tinymedicPatientOrderFile.cursor')}
                id="tinymedic-patient-order-file-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tinymedicPatientOrderFile.lastUpdated')}
                id="tinymedic-patient-order-file-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tinymedicPatientOrderFile.microSec')}
                id="tinymedic-patient-order-file-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.tinymedicPatientOrderFile.timestampEntry')}
                id="tinymedic-patient-order-file-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="tinymedic-patient-order-file-tinymedicPatientOrder"
                name="tinymedicPatientOrder"
                data-cy="tinymedicPatientOrder"
                label={translate('tinyMedicRestApp.tinymedicPatientOrderFile.tinymedicPatientOrder')}
                type="select"
              >
                <option value="" key="0" />
                {tinymedicPatientOrders
                  ? tinymedicPatientOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/tinymedic-patient-order-file"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TinymedicPatientOrderFileUpdate;
